
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-bd9a580c\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./customerDataPackageSetting.vue")
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-bd9a580c\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./customerDataPackageSetting.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./customerDataPackageSetting.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bd9a580c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./customerDataPackageSetting.vue"),
  /* scopeId */
  "data-v-bd9a580c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/developerInfo/components/customerDataPackageSetting.vue
// module id = 2401
// module chunks = 68